/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2020
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import MoserObject from './MoserObject';
import PromptTypeValues from './PromptTypeValues';
//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper
//@import com/ibm/bi/platform/moser/common/generated/metadata/PromptTypeValues (runtime) // new

/**
 * <p>Java class for promptInfoType complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType name="promptInfoType"&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="promptType" type="{}promptTypeValues"/&gt; &lt;element name="promptCascadeOnRef" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="promptDisplayItemRef" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="promptFilterItemRef" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="promptUseItemRef" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
export default class PromptInfoType extends MoserObject{

	promptType = null;

	promptCascadeOnRef = null;

	promptDisplayItemRef = null;

	promptFilterItemRef = null;

	promptUseItemRef = null;



	/**
	 * Gets the value of the promptType property.
	 * @return {PromptTypeValues} possible object is {@link PromptTypeValues}
	 */
	getPromptType() {
		return this.promptType;
	}

	/**
	 * Sets the value of the promptType property.
	 * @param {PromptTypeValues} value allowed object is {@link PromptTypeValues}
	 */
	setPromptType(value) {
		var oldValue = this.promptType;
		this.promptType = value;
		this._setAndNotify(19, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the promptCascadeOnRef property.
	 * @return {String} possible object is {@link String}
	 */
	getPromptCascadeOnRef() {
		return this.promptCascadeOnRef;
	}

	/**
	 * Sets the value of the promptCascadeOnRef property.
	 * @param {String} value allowed object is {@link String}
	 */
	setPromptCascadeOnRef(value) {
		var oldValue = this.promptCascadeOnRef;
		this.promptCascadeOnRef = value;
		this._setAndNotify(20, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the promptDisplayItemRef property.
	 * @return {String} possible object is {@link String}
	 */
	getPromptDisplayItemRef() {
		return this.promptDisplayItemRef;
	}

	/**
	 * Sets the value of the promptDisplayItemRef property.
	 * @param {String} value allowed object is {@link String}
	 */
	setPromptDisplayItemRef(value) {
		var oldValue = this.promptDisplayItemRef;
		this.promptDisplayItemRef = value;
		this._setAndNotify(23, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the promptFilterItemRef property.
	 * @return {String} possible object is {@link String}
	 */
	getPromptFilterItemRef() {
		return this.promptFilterItemRef;
	}

	/**
	 * Sets the value of the promptFilterItemRef property.
	 * @param {String} value allowed object is {@link String}
	 */
	setPromptFilterItemRef(value) {
		var oldValue = this.promptFilterItemRef;
		this.promptFilterItemRef = value;
		this._setAndNotify(21, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the promptUseItemRef property.
	 * @return {String} possible object is {@link String}
	 */
	getPromptUseItemRef() {
		return this.promptUseItemRef;
	}

	/**
	 * Sets the value of the promptUseItemRef property.
	 * @param {String} value allowed object is {@link String}
	 */
	setPromptUseItemRef(value) {
		var oldValue = this.promptUseItemRef;
		this.promptUseItemRef = value;
		this._setAndNotify(22, oldValue, value, false, false);
	}

	/**
	 * Creates a new instance of <code>PromptInfoType</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> PromptInfoType</code> object from.
	 * @return {PromptInfoType} an object of type <code>PromptInfoType</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createPromptInfoType();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "PromptInfoType";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(false, true, false, 19, "promptType", PromptTypeValues));
		featureList.push(this.createFeature(false, false, false, 20, "promptCascadeOnRef", null));
		featureList.push(this.createFeature(false, false, false, 23, "promptDisplayItemRef", null));
		featureList.push(this.createFeature(false, false, false, 21, "promptFilterItemRef", null));
		featureList.push(this.createFeature(false, false, false, 22, "promptUseItemRef", null));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 19:
			this.setPromptType((value));
			break;
		case 20:
			this.setPromptCascadeOnRef((value));
			break;
		case 21:
			this.setPromptFilterItemRef((value));
			break;
		case 22:
			this.setPromptUseItemRef((value));
			break;
		case 23:
			this.setPromptDisplayItemRef((value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 19:
			return this.getPromptType();
		case 20:
			return this.getPromptCascadeOnRef();
		case 21:
			return this.getPromptFilterItemRef();
		case 22:
			return this.getPromptUseItemRef();
		case 23:
			return this.getPromptDisplayItemRef();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 19:
			return this.getPromptType();
		case 20:
			return this.getPromptCascadeOnRef();
		case 21:
			return this.getPromptFilterItemRef();
		case 22:
			return this.getPromptUseItemRef();
		case 23:
			return this.getPromptDisplayItemRef();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}
}


// WEBPACK FOOTER //
// ./src/generated/PromptInfoType.js